// src/pages/Media.js
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import GlobalFooter from "../../components/GlobalFooter";
import piston from "../../assets/images/piston.jpg";
import singleTurbine from "../../assets/images/single-turbine.jpg";
import multiTurbine from "../../assets/images/multi-turbine.jpg";

const panels = [
  {
    image: piston,
    label: "PISTON AIRCRAFTS",
    description: "Includes Cirrus & Cessna Skyhawk",
    link: "/media/piston",
  },
  {
    image: singleTurbine,
    label: "SINGLE TURBINES",
    description: "Includes Pilatus, Vision Jet & more.",
    link: "/media/singleturbine",
  },
  {
    image: multiTurbine,
    label: "MULTI-TURBINES",
    description: "Includes Golfstream g280, Latitude, CJ & more.",
    link: "/media/multiturbine",
  },
];

export default function Media() {
  return (
    <>
      {/* Push content below fixed header */}
      <div className="bg-black pt-12 md:pt-12">
        {/* Panels: stack on mobile, row on desktop */}
        <div className="flex flex-col md:flex-row w-full">
          {panels.map((p, idx) => (
            <Link
              key={idx}
              to={p.link}
              className="
                relative
                w-full md:w-1/3
                h-[33vh]    md:h-screen
                overflow-hidden
                group
              "
            >
              {/* Background image */}
              <img
                src={p.image}
                alt={p.label}
                className="absolute inset-0 w-full h-full object-cover"
              />

              {/* Dark overlay on hover */}
              <div className="absolute inset-0 bg-black/30 transition duration-300 group-hover:bg-black/60" />

              {/* Content */}
              <div className="absolute bottom-8 left-6 right-6 text-white">
                <h2 className="text-3xl font-bold mb-2">{p.label}</h2>
                <p className="mb-4 max-w-xs leading-snug">{p.description}</p>
                {/* Your button style */}
                <div className="mt-6 inline-flex items-center justify-between gap-3 px-8 py-4 h-20 rounded-full bg-white/10 hover:bg-white/20 text-white font-body font-semibold tracking-tight backdrop-blur-md transition duration-300 border border-white/30 text-lg">
                  <span>View Portfolio</span>
                  <ArrowRight className="w-6 h-6 stroke-[1.5]" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Footer follows panels naturally */}
      <GlobalFooter />
    </>
  );
}
